import type { CalculatorFormatValue } from '@elfsight/configurator-contracts';

export function processCalculatorValue(
  format: CalculatorFormatValue,
  value: string | undefined
) {
  if (!value?.trim()) {
    return '';
  }

  if (format?._mode === 'string') {
    return String(value);
  }

  const number = Number(value);
  if (!isNaN(number) && number !== Infinity) {
    return number;
  }

  return value;
}
